import { AbstractControl, UntypedFormArray, ValidatorFn } from '@angular/forms';
import { PopInfoDto } from '../dto/Validators/PopInfoDto';

export function SlouceniOddiluDodavatelValidator(popInfos: PopInfoDto[]): ValidatorFn {

  /**
   * Vstupní array zbaví duplicitních hodnot a pokud je výsledný počet 1, byly všechny hodnoty stejné.
   * @param array
   */
  var _validate = function (array: any[]): boolean {
    let withoutDuplicities: string[] = array.filter((value, index) => array.indexOf(value) == index);
    return withoutDuplicities.length == 1;
  }

  return (control: AbstractControl): { [key: string]: any | null } => {

    let oddily: AbstractControl[] = (control as UntypedFormArray)?.controls;

    //vlastní porovnání má smysl pouze, pokud je více oddílů (tj. min 2)
    if (oddily != void 0 && oddily.length > 1) {
      let cislaPop = oddily.map(odd => odd.get('cisloPop')?.value);

      let dodavatele: number[] = [];
      cislaPop.forEach(cisloPop => {
        let info: PopInfoDto[] = popInfos.filter(popInfo => popInfo.cisloPop == cisloPop);
        if (info.length > 0) {
          dodavatele.push(info[0].dodavatelId);
        }
      });

      if (!_validate(dodavatele)) {
        return { 'druhyRmError': 'Slučovat lze pouze oddíly jednoho a téhož vlastníka RM.' };
      }
    }

    return null;
  }
}
